import DocumentEditor from "./DocumentEditor.component";
import React from "react";
import {DETAILS_VIEW_TYPE} from "utils/constants.js";
import {snowplowTrackEvent} from "utils/snowplow.js";
import * as reduxSelectors from "../../../store/application.reducers";
import {useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import {Button, ButtonType} from "components/common/Button.component";
import {ArrowDownToLine, ArrowLeftToLineIcon} from "lucide-react";
import {ICON_SIZE} from "components/common/constants";


export const DocumentEditorPanel = (props) => {

    const userConfiguration = useSelector((store) => reduxSelectors.getUsersData(store));
    const navigate = useNavigate();
    const getEditorExternalApplicationName = () => {
        switch (props.type) {
            case DETAILS_VIEW_TYPE.TASK:
                return props.task.externalApplicationName;
            case DETAILS_VIEW_TYPE.HISTORY_TASK:
            case DETAILS_VIEW_TYPE.PROCESS:
                return props.task.applicationTypeName;
            case DETAILS_VIEW_TYPE.DOCUMENT:
                return props.task.applicationTypeName;
            default:
                return props.task.externalApplicationName;
        }
    }

    const getDocumentType = () => {
        return props.task.documentType;
    }

    const getEditorExternalId = () => {
        switch (props.type) {
            case DETAILS_VIEW_TYPE.TASK:
                return props.task.externalId;
            case DETAILS_VIEW_TYPE.HISTORY_TASK:
            case DETAILS_VIEW_TYPE.PROCESS:
                return props.task.externalApplicationId;
            case DETAILS_VIEW_TYPE.DOCUMENT:
                return props.task.claimId;
            default:
                return props.task.externalId;
        }
    }

    const trackPanelCollapsing = (isCollapsed) => {
        snowplowTrackEvent({
            category: "external_editor_panel",
            action: "external_editor_collapsing",
            label: "external_editor_panel",
            value: isCollapsed ? "collapsed" : "extended"
        }, userConfiguration);
    }

    const applicationName = props.task.externalApplicationName || props.task.applicationTypeName || '';
    const externalApplicationNameKey = applicationName.replace(/[ .]/g, '');
    const isCompelloTask = !props.task?.taskActions?.includes('postpone');

    if (props.taskDetails.externalEditorAvailable) {
        return (
            <div className={`grid-layout-editor ${props.renderInPortal ? 'in-portal' : ''}`}
                 data-cy="taskDetail.externalEditorPanel">
                <div className="grid-panel-wrapper">
                    <div className="grid-panel">
                        <div className="grid-panel-header d-flex justify-content-between align-items-center">
                            <strong>
                                {props.translate("taskDetail.externalEditor")} {props.translationKeyExists(`taskDetail.applicationName.${externalApplicationNameKey}`) ?
                                props.translate(`taskDetail.applicationName.${externalApplicationNameKey}`) : applicationName}
                            </strong>
                            <div className="d-flex gap-8">
                                <Button type={ButtonType.GHOST}
                                        onClick={() => {
                                            trackPanelCollapsing(true);
                                            props.onRenderInPortalChange(true);
                                        }}
                                        disabled={props.renderInPortal}
                                        title={props.translate("taskDetail.placeAtTheSide")}
                                        iconOnly={true}
                                        icon={<ArrowLeftToLineIcon size={ICON_SIZE.MEDIUM}/>}/>
                                <Button type={ButtonType.GHOST}
                                        onClick={() => {
                                            trackPanelCollapsing(false);
                                            props.onRenderInPortalChange(false);
                                        }}
                                        disabled={!props.renderInPortal}
                                        title={props.translate("taskDetail.placeAtTheBottom")}
                                        iconOnly={true}
                                        icon={<ArrowDownToLine size={ICON_SIZE.MEDIUM}/>}/>
                            </div>

                        </div>
                        <div className={`grid-editor ${props.renderInPortal ? "" : "grid-editor-large"}`}>
                            <DocumentEditor translate={props.translate}
                                            taskId={props.params.taskId}
                                            id={props.taskDetails ? props.taskDetails.id : null}
                                            isCompelloTask={isCompelloTask}
                                            isHistory={props.isHistory}
                                            isReadOnly={props.editorReadOnly || props.taskDetails.readonly}
                                            externalAppId={getEditorExternalId()}
                                            externalApplicationName={getEditorExternalApplicationName()}
                                            documentType={getDocumentType()}
                                            companyId={props.task.companyId}
                                            reapproveType={props.taskDetails ? props.taskDetails.reapproveType : null}
                                            route={navigate}
                                            viewType={props.type}
                                            isPopup={false}/>
                        </div>
                    </div>
                </div>
            </div>
        );
    } else {
        return null;
    }

}

export default DocumentEditorPanel;